import { render, staticRenderFns } from "./editResourceStore.vue?vue&type=template&id=583013dc&scoped=true"
import script from "./editResourceStore.vue?vue&type=script&lang=js"
export * from "./editResourceStore.vue?vue&type=script&lang=js"
import style0 from "./editResourceStore.vue?vue&type=style&index=0&id=583013dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583013dc",
  null
  
)

export default component.exports